export enum NavCustomizationSetting {
    AppsHidden = 'NavCustomization.AppsHidden',
    ResourceCenterHidden = 'NavCustomization.ResourceCenterHidden',
    MarketplaceHidden = 'NavCustomization.MarketplaceHidden',
    StudioWebHidden = 'NavCustomization.StudioWebHidden',
}
